import { ColDef, GridApi } from "ag-grid-community";
import { makeObservable, observable } from "mobx";
import { EntityTypes, GridTypes } from "../../../../../../../enums";
import { ILocalStorageService } from "../../../../../../../services/local/localStorageService/ILocalStorageService";
import LocalStorageService from "../../../../../../../services/local/localStorageService/LocalStorageService";
import { IGridAddon } from "./IGridAddon";
interface ITextWrapperAddonProps {}

export class TextWrapperAddon implements IGridAddon<ITextWrapperAddonProps> {
  storageService: ILocalStorageService;
  gridApi: GridApi<any>;
  @observable isWrappedText: boolean;
  wrapTextKey: string;
  projectId: number;
  gridType: EntityTypes | GridTypes;

  constructor(projectId: number, gridType: EntityTypes | GridTypes) {
    makeObservable(this);
    this.storageService = LocalStorageService;
    this.projectId = projectId;
    this.gridType = gridType;
    this.wrapTextKey = `projects-${this.projectId}-${this.gridType}-wrap-text`;
    this.isWrappedText =
      (typeof this.storageService.get(this.wrapTextKey) !== "undefined" &&
        this.storageService.get(this.wrapTextKey) === "1") ||
      this.isWrappedText;
  }

  toggleTextWrap = () => {
    this.isWrappedText = !this.isWrappedText;
    this.updateCells();
  };

  onGridReady = (gridApi: GridApi<any>) => {
    this.gridApi = gridApi;
    this.updateCells();
  };

  updateCells = () => {
    if (!this.gridApi) {
      throw new Error("this.gridApi is not set on the text wrapper addon");
    }
    let cols = this.gridApi.getColumnDefs();
    if (!cols) {
      return;
    }

    cols.forEach((e: ColDef) => {
      e.wrapText = this.isWrappedText;
      e.autoHeight = this.isWrappedText;
    });

    this.storageService.set(this.wrapTextKey, this.isWrappedText ? "1" : "0");
    this.gridApi.setGridOption("columnDefs", cols);
  };

  getProps = () => {
    return {};
  };
}
